























import { Vue, Component, Prop } from 'vue-property-decorator';

import RouteTimesItem from '~/components/lists/items/RouteTimesItem.vue';

@Component({
  components: { RouteTimesItem },
})
export default class RouteTimes extends Vue {
  @Prop(Array) times: [];
  @Prop(Boolean) isLoading: false;
}
